module.exports = __webpack_public_path__ + "img/frame2.20b8a8ae.png";